import './bootstrap';
import '../scss/app.scss';
import '../../node_modules/vue-multiselect/dist/vue-multiselect.css';

import { createApp, h } from 'vue';
import { createInertiaApp, Head, Link } from '@inertiajs/vue3';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { ZiggyVue } from '../../vendor/tightenco/ziggy/dist/vue.m';
import { createPinia } from 'pinia';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { fas } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';
import VWave from 'v-wave';
import VueApexCharts from 'vue3-apexcharts';

/* For translation / localization */
import translations from '@/Composables/useTranslations.js';
/* ============ */
// app components
import { jsonTranslator } from '@/bootstrap';
import { createI18n } from 'vue-i18n';
/* ============ */

library.add(fas);

createInertiaApp({
  resolve: (name) => {
    const page = resolvePageComponent(
      `./Pages/${name}.vue`,
      import.meta.glob('./Pages/**/*.vue'),
    );
    page.then((module) => {
      //module.default.layout = module.default.layout != false ? module.default.layout || AppLayout : '';
    });
    return page;
  },
  setup({ el, App, props, plugin }) {
    /*
                        const addDevWord = async (word = null) => {
                          try {
                            if(!word) return;
                            const response = await axios.post('/dev/add-word', { word });

                          } catch (error) {
                            console.error(
                                'Error:',
                                error.response ? error.response.data : error.message,
                            );
                          }
                        };
                         */
    const i18n = createI18n({
      legacy: false, // for composition API
      locale: 'en',
      messages: {},
      missing: (locale, key) => {
        /* doesnt make sense to use this code since we can teach all with this command:  npm run extract-i18n
                                                // only if locale is DEV_TEACHER
                                                if (locale === 'DEV_TEACHER') {

                                                  addDevWord(key);
                                                  const currentMessages = i18n.global.getLocaleMessage(locale);
                                                  // add the key above to the messages
                                                  i18n.global.setLocaleMessage(locale, {
                                                    ...currentMessages,
                                                    [key]: key,
                                                  });
                                                }
                                        
                                                 */

        return key;
      },
    });

    const app = createApp({ render: () => h(App, props) })
      .use(plugin)
      .use(ZiggyVue, Ziggy)
      .use(createPinia())
      .use(VueApexCharts)
      .use(i18n)
      .use(VWave, {
        initialOpacity: 0.4,
        easing: 'ease-in',
        duration: 0.4,
      });

    app.component('Head', Head);
    app.component('Link', Link);
    app.component('fa', FontAwesomeIcon);
    app.config.globalProperties.$route = window.route = route;
    app.config.globalProperties.moment = window.moment = moment;
    app.config.globalProperties.ago = (val, postProcess = (r) => r) =>
      postProcess(val ? moment(val).fromNow() : '');
    app.config.globalProperties.humanizeDuration = (val) =>
      val ? moment.duration(val).humanize() : '';
    app.config.globalProperties.formatNumber = window.formatNumber = (
      val,
      precision = 2,
    ) => (val ? parseFloat(val).toFixed(precision) : '');
    app.config.globalProperties.formatPrettyNumber = window.formatPrettyNumber =
      (val, precision = 0) =>
        val
          ? parseFloat(val).toLocaleString(undefined, {
              minimumFractionDigits: precision,
              maximumFractionDigits: precision,
            })
          : '0';
    app.config.globalProperties.randomKey = window.randomKey = (val = null) =>
      val ?? Date.now().toString() + Math.random();

    app.config.globalProperties.__ = window.__ = (key, replacements = {}) =>
      translations(key, (replacements = {}));
    app.config.globalProperties.___ = window.___ = jsonTranslator;
    app.mount(el);
    return app;
  },
  progress: {
    color: '#009ef7',
    showSpinner: true,
  },
});
